import { inject, Injectable } from '@angular/core';

import { UserInvitationCacheService } from '@core/tellent-logic';
import { InviteMethod, StepDefinition, UserInvitationFlow } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class InvitationFlowStepService {
  private readonly userInvitationCacheService = inject(UserInvitationCacheService);

  public readonly flowStepMap: Record<UserInvitationFlow, StepDefinition[]> = {
    [UserInvitationFlow.AddMemberBasic]: [
      { step: 'add_member_new', initialData: { flowType: UserInvitationFlow.AddMemberBasic } },
      { step: 'assign_members_to_jobs', canMatch: data => !!data.displayAutj },
      { step: 'member_added_success' },
    ],
    [UserInvitationFlow.AddMemberAdvanced]: [
      {
        step: 'add_member_new',
        initialData: { flowType: UserInvitationFlow.AddMemberAdvanced },
      },
      {
        step: 'assign_members_to_jobs',
        canMatch: data => data.inviteMethod === InviteMethod.Email && !!data.displayAutj,
      },
      { step: 'download_credentials', canMatch: data => data.inviteMethod === InviteMethod.Login },
      { step: 'subdomain_information', canMatch: data => data.inviteMethod === InviteMethod.Login },
      { step: 'member_added_success' },
    ],
    [UserInvitationFlow.AddEmployeeForPreonboarding]: [
      {
        step: 'journey_promo_dialog',
        canMatch: () => this.shouldDisplayJourneysPromo(),
      },
      {
        step: 'add_employee_for_preonboarding',
        initialData: { flowType: UserInvitationFlow.AddEmployeeForPreonboarding },
      },
    ],
    [UserInvitationFlow.AddEmployeeWithoutAccess]: [
      {
        step: 'add_employee_without_access',
        initialData: { flowType: UserInvitationFlow.AddEmployeeWithoutAccess },
      },
      { step: 'member_added_success' },
      {
        step: 'journey_promo_dialog',
        canMatch: data => this.shouldDisplayJourneysPromo() && !!data.startPreonboarding,
      },
    ],
    [UserInvitationFlow.InviteExistingMember]: [
      {
        step: 'invite_existing_member',
        initialData: { flowType: UserInvitationFlow.InviteExistingMember },
      },
      { step: 'download_credentials', canMatch: data => data.inviteMethod === InviteMethod.Login },
      { step: 'subdomain_information', canMatch: data => data.inviteMethod === InviteMethod.Login },
      { step: 'member_added_success' },
    ],
    [UserInvitationFlow.InviteExistingMemberForPreonboarding]: [
      {
        step: 'journey_promo_dialog',
        canMatch: () => this.shouldDisplayJourneysPromo(),
      },
      {
        step: 'invite_existing_member_for_preonboarding',
        initialData: { flowType: UserInvitationFlow.InviteExistingMemberForPreonboarding },
      },
      { step: 'member_added_success' },
    ],
  };

  private shouldDisplayJourneysPromo(): boolean {
    return this.userInvitationCacheService.getJourneysPromoDialogFlag() !== true;
  }
}
